import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, List, ListItem, Text, TableItem, TableRow, TableBody, Table} from 'spectacle';
import {Slide} from '../../components/slide';
import {EstimateWithSprints} from '../../presentation';

interface OwnProps {
    estimateWithSprints: EstimateWithSprints;
}

export const ProjectDetail: FunctionComponent<OwnProps> = ({estimateWithSprints}) => {
    return (
        <Slide>
            <Heading size={3} textAlign="left" textColor="secondary">
                {estimateWithSprints.estimates[0].owner.name}
            </Heading>
            <Text textColor="secondary" textFont="secondary" textAlign="left">
                {estimateWithSprints.estimates
                    .reduce((names: string[], estimate) => {
                        if (names.indexOf(estimate.name) === -1) {
                            return [...names, estimate.name];
                        }
                        return names;
                    }, [])
                    .join(', ')}
            </Text>
            <Table style={{marginTop: '30px'}}>
                <TableBody>
                    {estimateWithSprints.sprintsLastWeek.length > 0 ? (
                        <>
                            <TableRow>
                                <TableItem textSize="2.66rem" textFont="secondary" textColor="tertiary">
                                    Last week:
                                </TableItem>
                                <TableItem textSize="2.66rem" textFont="secondary" textColor="tertiary">
                                    {estimateWithSprints.sprintsLastWeek
                                        .map((sprint) => sprint.employee.name)
                                        .join(', ')}
                                </TableItem>
                            </TableRow>
                        </>
                    ) : null}
                    {estimateWithSprints.sprintsThisWeek.length > 0 ? (
                        <>
                            <TableRow>
                                <TableItem bold textSize="2.66rem" textFont="secondary">
                                    This week:
                                </TableItem>
                                <TableItem textSize="2.66rem" textFont="secondary">
                                    {estimateWithSprints.sprintsThisWeek
                                        .map((sprint) => sprint.employee.name)
                                        .join(', ')}
                                </TableItem>
                            </TableRow>
                        </>
                    ) : null}
                </TableBody>
            </Table>
        </Slide>
    );
};
